import React from 'react';
import PropTypes from 'prop-types';
import {withRouter} from 'react-router';
import StressLevels from './StressLevels';
import StressSection from './StressSection';

const Health = ({onChange, onNext, health}) => (
  <StressSection
    heading="Physical"
    subheading="Stress"
    description="What is your stress level related to how your body feels today?"
    nextLabel="Next"
    onDone={() => onNext('/dashboard')}
    back="/stress/clock"
  >
    <StressLevels selected={health} onSelect={onChange('health')}/>
  </StressSection>
);

Health.propTypes = {
  onChange: PropTypes.func.isRequired,
  onNext: PropTypes.func.isRequired,
  health: PropTypes.number.isRequired
};

export default withRouter(Health);



// WEBPACK FOOTER //
// ./src/pages/Stress/Health.js